<template>
  <page-view class="max-height shopline">
    <img :src="require(`@/assets/shopline-logo.svg`)" class="m-b-4" />
    <template v-if="!done && error">
      <p class="error"></p>
      <div class="ta-c page-placeholder-text">
        <h2>Something went wrong. Please try again.</h2>
      </div>
    </template>
    <template v-else-if="done">
      <p class="success"></p>
      <div class="ta-c page-placeholder-text">
        <h2>You have successfully connected to Shopline!</h2>
        <p>
          You can <a href="/broadcast/schedule" @click.prevent="$router.push('/broadcast/schedule')" class="link blue">create a new broadcast</a> to get started.
        </p>
      </div>
    </template>
    <template v-else>
      <div class="loading-spinner large m-a"></div>
    </template>
  </page-view>
</template>

<style lang="scss">
.shopline > .main .content {
  justify-content: center;
  align-items: center;
}
</style>

<script>

import { OauthService } from '@/services/oauth.service';

export default {
  async mounted() {
    this.$store.commit('Theme/shoplineMode');

    // eslint-disable-next-line
    const params = Object.fromEntries(new URLSearchParams(location.search));
    if (!params.appkey) {
      this.$router.replace('/dashboard');
      return;
    }

    try {
      await OauthService.createShoplineConnection(params);
      await this.$store.dispatch('AccountManager/getShoppingSettings');
      this.done = true;
    } catch (e) {
      this.error = true;
    }
  },
  data() {
    return {
      done: false,
      error: false,
    };
  },
};
</script>
